<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-03-27 14:01:24
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-09 11:39:05
 * @FilePath: \intelligent-knowledge-qa-pc\src\components\element\controller.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script lang="jsx">
export default {
  name: 'EController',
  props: {
    formType: {
      type: String,
      default: 'string',
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    }
  },
  setup(props) {
    let type = props.formType;
    if (type == 'string') {
      return () => <el-input />;
    } else if (type == 'number') {
      return () => <el-input-number />;
    } else if (type == 'select') {
      return () => (
        <el-select
          v-slots={{
            default: () => props.options.map((e) => <el-option {...e} />),
          }}
        ></el-select>
      );
    } else if (type == 'date') {
      return () => <el-date-picker />;
    } else if (type == 'time') {
      return () => <el-date-picker />;
    } else if (type == 'switch') {
      return () => <el-switch />;
    }
    return () => <el-input />;
  },
};
</script>
